import React from "react";

interface DropdownSelectorProps {
	options: string[];
	value: string;
	onChange: (value: string) => void;
	label?: string;
}

const DropdownComponent: React.FC<DropdownSelectorProps> = ({
	options,
	value,
	onChange,
	label = "Select an option",
}) => {
	return (
		<div>
			<select value={value} onChange={(e) => onChange(e.target.value)}>
				<option value="">{label}</option>
				{options.map((option) => (
					<option key={option} value={option}>
						{option}
					</option>
				))}
			</select>
		</div>
	);
};

export default DropdownComponent;
